export enum DashboardStatus {
    DEFAULT,
    LOADING,
    DONE,
    ERROR,
}